<template>
    <li class="nav-item">
        <a
            class="nav-link"
            :class="{ collapsed: index !== 0 }"
            href="#"
            data-toggle="collapse"
            :data-target="`#${labelSlug}`"
            aria-expanded="true"
            :aria-controls="labelSlug"
            @click.prevent="toggleCollapse"
        >
            <i class="fas fa-fw" :class="{ 'fa-chevron-down': !isCollapsed, 'fa-chevron-right': isCollapsed }"></i>
            <span>{{ label }}</span>
        </a>
        <div :id="labelSlug" class="collapse" :class="{ show: index === 0 }" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
            <div class="bg-white py-2 collapse-inner rounded">
                <!-- <h6 class="collapse-header">Custom Components:</h6> -->
                <a class="collapse-item" v-for="item in items" :key="item.id" @click.prevent="navigateTo(item.route)" href="#">{{ item.name }}</a>
            </div>
        </div>
    </li>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Menu',
        },
        items: {
            type: Array,
            default: () => [],
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        isCollapsed: true,
    }),
    computed: {
        labelSlug() {
            return slug(this.label)
        },
    },
    methods: {
        navigateTo(route) {
            if (this.$route.name === route) return
            this.$router.push({ name: route })
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed
        },
    },
}
</script>
